import React from 'react';
import ShareRewindSlideBase from './ShareRewindSlideBase';
import { RewindStats } from '../../utils/rewindStats';
import { useDisplayPreferences } from '../../hooks/useDisplayPreferences';

interface ShareRewindFirstTimeShipsSlideProps {
  year: number;
  stats: RewindStats;
}

const ShareRewindFirstTimeShipsSlide = React.forwardRef<HTMLDivElement, ShareRewindFirstTimeShipsSlideProps>(
  ({ year, stats }, ref) => {
    const { formatTonnage } = useDisplayPreferences();
    
    if (stats.firstTimeShips.length === 0) {
      return null;
    }

    // Limit to 6 ships for display (2x3 grid)
    const displayShips = stats.firstTimeShips.slice(0, 6);

    return (
      <ShareRewindSlideBase ref={ref} year={year}>
        <div className="flex flex-col h-full">
          {/* Top Section - Title */}
          <div className="flex flex-col items-center justify-center text-center pt-20 pb-8">
            <div className="text-7xl font-bold text-white leading-none mb-4">
              First Time Ships
            </div>
            <div className="text-5xl text-white/90 font-medium">
              {stats.firstTimeShips.length} {stats.firstTimeShips.length === 1 ? 'Ship' : 'Ships'} Sailed for the First Time
            </div>
          </div>

          {/* Middle Section - Ship Grid */}
          <div className="flex-1 flex items-center justify-center px-8">
            <div className="grid grid-cols-2 gap-6 w-full max-w-4xl">
              {displayShips.map((ship, index) => (
                <div key={index} className="text-center">
                  {ship.imageUrl && (
                    <div className="mb-4 rounded-lg overflow-hidden bg-white/10 backdrop-blur-sm">
                      <img
                        src={ship.imageUrl}
                        alt={ship.shipName}
                        className="w-full h-48 object-cover"
                        crossOrigin="anonymous"
                      />
                    </div>
                  )}
                  <div className="text-4xl font-bold text-white mb-2">
                    {ship.shipName}
                  </div>
                  <div className="text-3xl text-white/90">
                    {ship.cruiseLine}
                  </div>
                  {ship.grossTonnage && (
                    <div className="text-2xl text-white/80 mt-2">
                      {formatTonnage(ship.grossTonnage)}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Bottom Section - Branding */}
          <div className="flex flex-col items-center text-center pb-12">
            <div className="text-4xl font-bold text-white leading-none mb-2">
              Cruising Along Rewind {year}
            </div>
          </div>
        </div>
      </ShareRewindSlideBase>
    );
  }
);

ShareRewindFirstTimeShipsSlide.displayName = 'ShareRewindFirstTimeShipsSlide';

export default ShareRewindFirstTimeShipsSlide;

